import { h } from 'preact';
import { SelectEntry } from '../entries/SelectEntry';
import { CheckboxEntry } from '../entries/CheckboxEntry';

const getBoundaryEvents = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'Timer', label: i18n['opt.Timer'] || 'Timer' },
  { value: 'Error', label: i18n['opt.Error'] || 'Error' },
  { value: 'Escalation', label: i18n['opt.Escalation'] || 'Escalation' },
  { value: 'Compensation', label: i18n['opt.Compensation'] || 'Compensation' },
  { value: 'Cancel', label: i18n['opt.Cancel'] || 'Cancel' },
  { value: 'Signal', label: i18n['opt.Signal'] || 'Signal' },
  { value: 'Message', label: i18n['opt.Message'] || 'Message' },
  { value: 'Conditional', label: i18n['opt.Conditional'] || 'Conditional' },
];

export class BoundaryPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:BoundaryEvent';
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'boundary',
        label: i18n.boundary || 'Boundary Event',
        entries: [
          {
            id: 'boundaryEvent',
            component: () => (
              <SelectEntry
                id="epx-boundary-event"
                label={i18n.boundaryEvent || 'Event'}
                value={props.trigger || ''}
                options={getBoundaryEvents(i18n)}
                onChange={(val) => update('trigger', val)}
              />
            ),
          },
          {
            id: 'isInterrupting',
            component: () => (
              <CheckboxEntry
                id="epx-is-interrupting"
                label={i18n.isInterrupting || 'Interrupting'}
                checked={props.isInterrupting !== false}
                onChange={(val) => update('isInterrupting', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
